// custom typefaces
import "@fontsource/fanwood-text"
import "@fontsource/questrial"

// custom CSS styles
import "./src/style.scss"
require("prismjs/plugins/line-numbers/prism-line-numbers.css")